module.exports = __webpack_public_path__ + "static/img/programme-bg.66a1b71c.png";